import React, { useEffect } from 'react';
import { useQueryParam, NumberParam, StringParam } from 'use-query-params';

import { ExperiencePage } from '@utriper/core-ui';

import Layout from 'components/Layout';
import { useTranslation } from 'core/contexts/localization';
import { ExperienceService } from 'core/api/services/experiences';
import { useExperiences } from 'core/contexts/experience';
import { useHostel } from 'core/contexts/hostel';
import { Box } from '@mui/material';

const Experience = () => {
    const [queryId, setQueryId] = useQueryParam('id', NumberParam);
    const [queryCode, setQueryCode] = useQueryParam('code', StringParam);

    const { addBookedExperienceWithQuantityPrice } = useExperiences();
    const { setCode } = useHostel();

    useEffect(() => {
        if (queryCode && queryCode?.length > 0) {
            setCode(queryCode);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryCode]);

    return (
        <Layout>
            <Box sx={{ width: '100%', pl: { xs: 2, md: 4 }, pr: { xs: 2, md: 0 } }}>
                <ExperiencePage experienceId={queryId} contractCode={queryCode} useTranslation={useTranslation} experienceService={ExperienceService} addBookedExperienceWithQuantityPrice={addBookedExperienceWithQuantityPrice} />
            </Box>
        </Layout>
    );
};
export default Experience;
